import { Helmet } from 'react-helmet-async';
import { useCallback, useEffect, useRef, useState } from 'react';
// @mui
import { Chip, Container, Grid, Stack, Typography } from '@mui/material';
// components
// mock
import { eventList, glb_sv, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import ProductCard from 'src/components/card/ProductCard';
import FillterCabinet from 'src/components/fillter/Fillter';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import { UserListToolbar } from 'src/sections/@dashboard/user';
import ProductFilterSidebar from 'src/components/fillter/ProductFilterSidebar';
import crypt from 'src/utils/service/crypt';
import Loader from 'src/components/loader/loader';
import { useParams } from 'react-router-dom';

// ----------------------------------------------------------------------

export default function BorrowingDeviceOnlineV2() {
    const getCabinetFlags = useRef();
    const [tableData, setTableData] = useState([]);
    const getDeviceFlags = useRef();
    const [dataCabinet, setDataCabinet] = useState([]);
    const [dataDrawer, setDataDrawer] = useState([]);
    const [valueCabinet, setValueCabinet] = useState(null);
    const [getFlags, setGetFlags] = useState(false);
    const [valueDrawer, setValueDrawer] = useState(null);
    const actionRef = useRef();
    const { t } = useTranslation();
    const cabinetRef = useRef();
    const [openFilter, setOpenFilter] = useState(false);
    const user = useRef({});
    const [arrProperties, setArrProperties] = useState([]);
    const arrFillters = useRef([]);

    const params = useParams();
    const path = window.location.pathname;
    user.current = glb_sv.userInfo;

    useEffect(() => {
        setTimeout(() => {
            // getData();
            // if (glb_sv.userInfo.group_user !== '3') {
            getDataCabinet();
            // }
        }, 1000);
    }, []);

    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');

        if (userData) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                user.current = data;
            } catch (error) {}
        }
    }, []);

    useEffect(() => {
        try {
            const getSessions = sessionStorage.getItem('cabinet');
            if (getSessions) {
                const ssCabinet = JSON.parse(getSessions);
                cabinetRef.current = ssCabinet;
                getDataDrawer(ssCabinet.id);
            }
        } catch (error) {}
        if (valueCabinet?.id) {
            getDataDrawer(valueCabinet.id);
        }
        if (valueCabinet?.id === 0) {
            setDataDrawer([{ drawer_nm: t('all'), id: 0 }]);
            setValueDrawer(null);
        }
    }, [valueCabinet?.id, arrProperties]);

    useEffect(() => {
        try {
            const getSessions = sessionStorage.getItem('cabinet');
            if (getSessions) {
                const ssCabinet = JSON.parse(getSessions);
                cabinetRef.current = ssCabinet;
                getDataDrawer(ssCabinet.id);
            }
        } catch (error) {}
        if (valueCabinet?.id && valueCabinet?.id !== 0) {
            getData(valueCabinet.id, valueDrawer?.id ? valueDrawer.id : null);
        }
        if (valueCabinet?.id === 0) {
            // glb_sv.userInfo.group_user !== '3' && getData();
            getData();
            setValueDrawer(null);
            setDataDrawer([{ drawer_nm: t('all'), id: 0 }]);
        }
        if (!valueCabinet?.id && valueDrawer?.id !== 0) {
            getData(cabinetRef.current?.id ? cabinetRef.current?.id : 0, valueDrawer?.id);
        }
    }, [valueCabinet?.id, valueDrawer?.id, arrProperties]);

    const getData = useCallback(
        (idCabin, idDraw) => {
            const arrFillters = arrProperties.map((item) => {
                const checkedValues = item.value
                    .filter((subItem) => subItem.checked === true)
                    .map((subItem) => subItem.value);
                return { label: item.label, value: checkedValues };
            });
            if (getDeviceFlags.current) {
                return;
            }
            setGetFlags(true);
            getDeviceFlags.current = true;
            // if (user.current.group_user !== '3') {
            if (!valueCabinet?.id && !valueDrawer?.id) {
                const InVal = [
                    user.current.depart_cd,
                    arrFillters.filter((item) => item.value.length > 0),
                    +params.idGroup,
                ];
                setTimeout(() => {
                    sendRequest(serviceList.getAllDeviceBorrow, InVal, getDataResult, true, timeOutFunct, 40000);
                }, 1000);
            }
            if (!valueDrawer?.id && valueCabinet?.id) {
                const InVal = [
                    valueCabinet.id,
                    user.current.depart_cd,
                    arrFillters.filter((item) => item.value.length > 0),
                    +params.idGroup,
                ];
                setTimeout(() => {
                    sendRequest(serviceList.getAllDeviceCabinet, InVal, getDataResult, true, timeOutFunct, 40000);
                }, 1000);
            }
            if (valueDrawer?.id && valueCabinet?.id) {
                const InVal = [
                    valueCabinet.id,
                    valueDrawer.id,
                    user.current.depart_cd,
                    arrFillters.filter((item) => item.value.length > 0),
                    +params.idGroup,
                ];
                setTimeout(() => {
                    sendRequest(serviceList.getAllDeviceBorrowDraw, InVal, getDataResult, true, timeOutFunct, 40000);
                }, 1000);
            }
            // } else {
            //     if (!valueDrawer?.id) {
            //         const InVal = [
            //             idCabin,
            //             user.current.depart_cd,
            //             arrFillters.filter((item) => item.value.length > 0),
            //             +params.idGroup,
            //         ];
            //         setTimeout(() => {
            //             sendRequest(serviceList.getAllDeviceCabinet, InVal, getDataResult, true, timeOutFunct, 40000);
            //         }, 1000);
            //     }
            //     if (valueDrawer?.id) {
            //         const InVal = [
            //             idCabin,
            //             idDraw,
            //             user.current.depart_cd,
            //             arrFillters.filter((item) => item.value.length > 0),
            //             +params.idGroup,
            //         ];
            //         setTimeout(() => {
            //             sendRequest(
            //                 serviceList.getAllDeviceBorrowDraw,
            //                 InVal,
            //                 getDataResult,
            //                 true,
            //                 timeOutFunct,
            //                 40000
            //             );
            //         }, 1000);
            //     }
            // }
        },
        [valueCabinet?.id, valueDrawer?.id, arrProperties]
    );
    const getDataResult = (reqInfoMap, message) => {
        getDeviceFlags.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
            arrFillters.current = message.proc_data.rows[0].o_1;
        }
    };

    const getDataCabinet = useCallback(() => {
        if (getCabinetFlags.current) return;
        getCabinetFlags.current = true;
        const InVal = [];
        sendRequest(serviceList.getAllCabinetSp, InVal, getDataCabinetResult, true, timeOutFunctCabinet, 40000);
    }, []);

    const getDataCabinetResult = (reqInfoMap, message) => {
        getCabinetFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataCabinet([
                { cabinet_nm: t('all'), id: 0 },
                ...message.proc_data.rows[0].o_1?.filter((ele) => ele.block_status === '1'),
            ]);
            setDataDrawer([{ drawer_nm: t('all'), id: 0 }]);
        }
    };

    const getDataDrawer = useCallback(
        (id) => {
            const InVal = [id];
            sendRequest(serviceList.getAlldrawerSp, InVal, getDataDrawerResult, true, timeOutFunct, 40000);
        },
        [valueCabinet?.id]
    );

    const getDataDrawerResult = (reqInfoMap, message) => {
        getDeviceFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataDrawer([{ drawer_nm: t('all'), id: 0 }, ...message.proc_data.rows[0].o_1]);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getDeviceFlags.current = false;
        setGetFlags(false);
    };
    const timeOutFunctCabinet = (reqInfo) => {
        getCabinetFlags.current = false;
        toast.error(t('error.time_out'));
    };

    const handleActionDevice = (data, qty, note, helper_device) => {
        if (actionRef.current) return;
        actionRef.current = true;
        const InVal = [0, data.cell_id, qty, 'exp', 'ebr', data.device_id, note, helper_device.id];
        sendRequest(serviceList.actionDeviceOnline, InVal, actionDeviceResult, true, timeOutFunctActionDevice, 40000);
    };
    const actionDeviceResult = (reqInfoMap, message) => {
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            glb_sv.commonEvent.next({ type: eventList.ADD_PRODUCT, data: 'add' });
            toast.success(message['proc_message'], { position: 'top-left' });
        }
    };

    const timeOutFunctActionDevice = (reqInfo) => {
        actionRef.current = false;
        toast.error(t('error.time_out'));
    };
    const fillterSearcher = (value) => {
        if (value === '' || !value) {
            return setTableData(arrFillters.current);
        }
        const arrSearch = arrFillters.current.filter(
            (data) => data.device_nm.includes(value.toUpperCase()) || data.device_cd.includes(value.toUpperCase())
        );
        setTableData(arrSearch);
    };
    const handleDelete = (item, index, indexParent) => {
        // arrProperties.splice(index, 1);
        // setArrProperties([...arrProperties]);
        if (item) {
            arrProperties[indexParent].value[index] = {
                ...arrProperties[indexParent].value[index],
                checked: !arrProperties[indexParent].value[index].checked,
            };
            setArrProperties([...arrProperties]);
        }
    };
    return (
        <>
            <Helmet>
                <title> {t('muon_online')} </title>
            </Helmet>

            <Container>
                <Typography variant="h4" sx={{ mb: 2 }}>
                    {t('muon_online')}
                </Typography>
                <Breadcrumb
                    paths={[
                        {
                            label: t('group_devices'),
                            url: `/home/group/${path?.split('/')[3]}/${params.idPermission}`,
                            navigate: false,
                        },
                        { label: t('muon_online'), url: '#', navigate: false },
                    ]}
                />
                <Loader loading={getFlags} />
                <Grid container spacing={3} alignItems={'center'}>
                    <Grid item xs={12} sm={12} md={6} xl={8}>
                        <UserListToolbar getValue={fillterSearcher} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} xl={4}>
                        <Stack
                            direction="row"
                            alignItems="center"
                            width={'100%'}
                            justifyContent="flex-end"
                            flexWrap={'wrap'}
                            gap={1}
                            sx={{ mb: 1 }}
                        >
                            <ProductFilterSidebar
                                valueChange={arrProperties}
                                openFilter={openFilter}
                                getValue={setArrProperties}
                                onCloseFilter={() => setOpenFilter(false)}
                                onOpenFilter={() => setOpenFilter(true)}
                            />
                            {/* {glb_sv.userInfo.group_user !== '3' && ( */}
                            <FillterCabinet
                                setValueSort={(data) => {
                                    setValueCabinet(data);
                                    setValueDrawer({ drawer_nm: t('all'), id: null });
                                }}
                                arrSort={dataCabinet}
                                labelDisplay="cabinet_nm"
                                defaultValue={dataCabinet.length > 0 ? dataCabinet[0].cabinet_nm : ''}
                                title={t('cabinet')}
                            />
                            {/* )} */}
                            <FillterCabinet
                                setValueSort={setValueDrawer}
                                labelDisplay="drawer_nm"
                                arrSort={dataDrawer}
                                valueSort={valueDrawer ? valueDrawer : null}
                                defaultValue={dataDrawer.length > 0 ? dataDrawer[0].drawer_nm : ''}
                                title={t('drawer')}
                            />
                        </Stack>
                    </Grid>{' '}
                    <Stack direction="row" flexWrap={'wrap'} padding={2} paddingBottom={0} spacing={1}>
                        {arrProperties.length > 0 &&
                            arrProperties.map((item, index) => {
                                return (
                                    <div key={index} style={{ gap: 1 }}>
                                        {item?.value?.length > 0 &&
                                            item.value.map((value, idx) => {
                                                if (value.checked) {
                                                    return (
                                                        <Chip
                                                            variant="outlined"
                                                            key={idx}
                                                            sx={{ marginLeft: 1 }}
                                                            label={glb_sv.convertMultipleLanguages(value?.label)}
                                                            color="primary"
                                                            // onClick={() => handleClick(item, index)}
                                                            onDelete={() => handleDelete(item, idx, index)}
                                                        />
                                                    );
                                                }
                                            })}
                                    </div>
                                );
                            })}
                    </Stack>
                </Grid>

                <Grid container spacing={3}>
                    {tableData.map((product, index) => {
                        if (product.status_action === '0') {
                            return (
                                <Grid key={index} item xs={6} sm={4} md={3} xl={2.4}>
                                    <ProductCard
                                        product={product}
                                        isBorrow
                                        functOnClick={handleActionDevice}
                                        isRegisterOnline
                                    />
                                </Grid>
                            );
                        }
                    })}
                </Grid>
            </Container>
        </>
    );
}
